import React from 'react';

import {string_to_color, hashCode} from "./baseFunctions";

export default class Chart extends React.Component {
  constructor(){
    super();
    this.update = this.update.bind(this);
    this.randomScalingFactor = this.randomScalingFactor.bind(this);
    this.chart = false;
    this.state = {
      name: "canvas" + Math.round(Math.random()*10000)
    };
  }
  componentDidMount(){
    this.update();
  }
  randomScalingFactor(){
    return Math.round((Math.round(Math.random()*200)));
  }
  update(){
    console.log("ChartJS", this.props);
    let barData = {
      labels: this.props.labels,
      datasets: []
    };
    barData.datasets = this.props.data.map((d) => {
      const COLOR = string_to_color(hashCode(d.name).toString(), 28);
      return {
        label: d.name,
        backgroundColor: "#" + COLOR,
        borderColor: "#" + COLOR,
        borderWidth: 1,
        data: d.data
      };
    });
    /*{
        label: 'Dataset 1',
        backgroundColor: "#ff0808",
        borderColor: "#ff0808",
        borderWidth: 1,
        data: [
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor()
        ]
      }, {
        label: 'Dataset 2',
        backgroundColor: "#93ff08",
        borderColor: "#93ff08",
        data: [
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor(),
          this.randomScalingFactor()
        ]
      }*/

      console.log(barData);
    let ctx = this.refs.canvas.getContext('2d');
    this.chart = new window.Chart(ctx, {
        type: 'horizontalBar',
        data: barData,
        options: {

          // Elements options apply to all of the options unless overridden in a dataset
          // In this case, we are setting the border of each horizontal bar to be 2px wide
          elements: {
            rectangle: {
              borderWidth: 2,
            }
          },
          responsive: true,
          legend: {
            position: 'right',
            display: this.props.hideLegend ? false : (window.innerWidth >= 1400),
          },
          title: {
            display: true,
            text: this.props.title
          },
          tooltips: {
           mode: 'label',
           intersect: false,
           callbacks: {
                label: function(tooltipItem, data) {
                    if(typeof tooltipItem.xLabel === "number" && !window.isNaN(tooltipItem.xLabel))
                    {
                      var label = data.datasets[tooltipItem.datasetIndex].label || '';

                      if (label) {
                          label += ': ';
                      }
                      label += tooltipItem.xLabel;
                      return label;
                    }
                    return "";
                }
              }
         } 
        }
      });


  }



	render(){

		return (<canvas id={this.state.name} ref="canvas"></canvas>);
	}
}


// WEBPACK FOOTER //
// ./src/components/Chart.js